import { useEffect, useState } from "react";
import { Segmented, Select } from "antd";
import { TableOutlined, AppstoreOutlined, ShopOutlined } from "@ant-design/icons";
import { AdminMenuLayout, PageCard } from "../../../shared/components";
import { TableOrders } from "./TableOrders";
import { OrdersKanban } from "./OrdersKanban";
import { storesService } from "../../../shared/services";

export const Orders = () => {
  const [viewMode, setViewMode] = useState<"kanban" | "table">("kanban");
  const [storeFilter, setStoreFilter] = useState<number | undefined>();
  const [storeOptions, setStoreOptions] = useState<
    { label: string; value: number }[]
  >([]);

  useEffect(() => {
    storesService
      .find({ query: { $limit: 500, $sort: { name: 1 } } })
      .then((res) => {
        const rows = "data" in res ? res.data : [];
        const list = Array.isArray(rows) ? rows : [];
        setStoreOptions(
          (list as { id: number; name: string; address?: string }[]).map(
            (s) => ({
              value: s.id,
              label: s.address?.trim()
                ? `${s.name} — ${s.address}`
                : s.name,
            })
          )
        );
      })
      .catch(() => setStoreOptions([]));
  }, []);

  return (
    <AdminMenuLayout pageDescription="Gestión de pedidos" title="Pedidos">
      <PageCard
        title="Listado de Pedidos"
        action={
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            <Select
              allowClear
              showSearch
              placeholder="Todas las sedes"
              optionFilterProp="label"
              style={{ minWidth: 260, maxWidth: 360, height: 40 }}
              suffixIcon={<ShopOutlined />}
              options={storeOptions}
              value={storeFilter}
              onChange={(v) => setStoreFilter(v)}
            />
            <Segmented
              options={[
                {
                  label: (
                    <div style={{ padding: "0 8px", display: "flex", alignItems: "center", gap: 8, height: 32 }}>
                      <AppstoreOutlined />
                      <span>Kanban</span>
                    </div>
                  ),
                  value: "kanban",
                },
                {
                  label: (
                    <div style={{ padding: "0 8px", display: "flex", alignItems: "center", gap: 8, height: 32 }}>
                      <TableOutlined />
                      <span>Tabla</span>
                    </div>
                  ),
                  value: "table",
                },
              ]}
              value={viewMode}
              onChange={(value) => setViewMode(value as "kanban" | "table")}
              size="large"
            />
          </div>
        }
      >
        <div style={{ minHeight: 600 }}>
          {viewMode === "kanban" ? (
            <OrdersKanban storeId={storeFilter} />
          ) : (
            <TableOrders storeId={storeFilter} />
          )}
        </div>
      </PageCard>
    </AdminMenuLayout>
  );
};
